var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "46", height: "70", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "filter",
        { x: "-18.9%", y: "-7.6%", width: "137.8%", height: "121.2%", filterUnits: "objectBoundingBox", id: "a-bolt-ProductPackageScreen" },
        React.createElement("feOffset", { dy: "2", "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
        React.createElement("feGaussianBlur", { stdDeviation: "2", "in": "shadowOffsetOuter1", result: "shadowBlurOuter1" }),
        React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0", "in": "shadowBlurOuter1" })
      ),
      React.createElement("path", { d: "M749.37 198.644l-11.247.673 1.704-24.2c0-1.345-1.704-2.017-2.385-.673l-23.175 38.653c-.681 1.009 0 2.017 1.364 2.017l11.927-.336-2.044 23.528c0 1.345 1.704 2.017 2.385.672l22.834-37.98c.681-1.01 0-2.354-1.364-2.354z", id: "b-bolt-ProductPackageScreen" })
    ),
    React.createElement(
      "g",
      { transform: "rotate(10 1372.415 -3932.242)", fill: "none" },
      React.createElement("use", { fill: "#000", filter: "url(#a-bolt-ProductPackageScreen)", xlinkHref: "#b-bolt-ProductPackageScreen" }),
      React.createElement("use", { fill: "#FF4DC4", xlinkHref: "#b-bolt-ProductPackageScreen" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/apps/boosts/components/svgs/bolt.svg